import React, { ReactNode } from 'react'

interface State {
  innerHeight: number
  pageYOffset: number
}

interface Props {
  render(state: State): ReactNode
}

class Scroll extends React.Component<Props, State> {
  displayName = 'Scroll'

  componentDidMount = () => window.addEventListener('scroll', this.onScroll)

  componentWillUnmount = () => window.removeEventListener('scroll', this.onScroll)

  onScroll = () =>
    this.setState({
      pageYOffset: window.pageYOffset,
      innerHeight: window.innerHeight,
    })

  render = () => this.props.render({ ...this.state })
}

export default Scroll
